import { render, staticRenderFns } from "./InfoHover.vue?vue&type=template&id=140c1a5f&scoped=true"
import script from "./InfoHover.vue?vue&type=script&lang=js"
export * from "./InfoHover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140c1a5f",
  null
  
)

export default component.exports